import { XIcon, Share2Icon } from 'lucide-react';
import { motion } from 'framer-motion';

interface SnapFeedHeaderProps {
  showVoted: boolean;
  onClose: () => void;
  onShare: () => void;
}

export default function SnapFeedHeader({ showVoted, onClose, onShare }: SnapFeedHeaderProps) {
  return (
    <>
      {/* Close button - top right */}
      <button 
        onClick={onClose}
        className="absolute top-4 right-4 z-20 bg-black/50 text-white p-2 rounded-full backdrop-blur-sm"
        aria-label="Close"
      >
        <XIcon className="h-6 w-6" />
      </button>
      
      {/* Share button - top left */}
      <button 
        onClick={onShare}
        className="absolute top-4 left-4 z-20 bg-black/50 text-white p-2 rounded-full backdrop-blur-sm"
        aria-label="Share"
      >
        <Share2Icon className="h-6 w-6" />
      </button>
      
      {/* Voted/Not Voted indicator */}
      <div className="absolute top-4 left-1/2 transform -translate-x-1/2 z-20">
        <div className="bg-black/50 text-white px-4 py-2 rounded-full backdrop-blur-sm flex items-center">
          <div className={`w-3 h-3 rounded-full mr-2 ${showVoted ? 'bg-primary-500' : 'bg-blue-500'}`}></div>
          <span>{showVoted ? 'Voted' : 'Not Voted'}</span>
        </div>
      </div>
    </>
  );
}